class MFRHostedVideo {
    constructor( index, element ) {
        this.$index = index;
        this.$element = $( element );

        this.init();
    }

    init() {
        this.$video = this.$element.find( "video" );
        this.$cover = this.$element.find( ".mfr-components__video-cover" );
        this.$playPauseButton = this.$element.find( ".mfr-components__video-icon" );

        this.$video.on( "play", this.__handleVideoPlay.bind( this ) );
        this.$video.on( "pause", this.__handleVideoPause.bind( this ) );

        this.$cover.on( "click", this.__handleVideoClick.bind( this ) );
    }

    __handleVideoPlay( e ) {
        this.$cover.addClass("is-hidden"); // Hide cover when video plays
        console.log('playing');
        this.$element.toggleClass( "is-playing", !e.currentTarget.paused );
    }
 
    __handleVideoPause( e ) {
        this.$cover.removeClass("is-hidden"); // Show cover when video is paused
        console.log('paused');
        this.$element.toggleClass( "is-playing", !e.currentTarget.paused );
    }

    __handleVideoClick( e ) {
        if( $( e.currentTarget ).attr( "controls" ) ) return;

        // Get the actual video DOM element from the jQuery object
        let videoElement = this.$video.get(0);

        if( videoElement.paused )
            videoElement.play();
        else
            videoElement.pause();
        
        // if( e.currentTarget.paused )
        //     e.currentTarget.play()
        // else
        //     e.currentTarget.pause();
    }
}